import { UPDATEDEFAULTFLAG_SUCCESS, UPDATEDEFAULTFLAG_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const updateDefaultFlagReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEDEFAULTFLAG_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEDEFAULTFLAG_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateDefaultFlagReducer;
